import React, { ReactElement } from "react"
import Layout from "../components/layout"
import CSharp from "../components/csharp"
import Shell from "../components/shell"
import { Link } from "gatsby"

const code = `var validator = new ValidatorBuilder<Employee>()
    .Required(e => e.FirstName)
    .Email(e => e.Email)
    .For(e => e.LastName, name =>
    {
        name.MinLength(5)
            .Equal("Smithers");
    })
    .Build();

var result = validator.Validate(
    new Employee 
    { 
        LastName = "Simpson",
        Email = "homer[at]springfieldnuclear.com"
    }
);

foreach (var rule in result.BrokenRules)
{
    Console.WriteLine($"[{rule.Rule}] {rule.Key}: {rule.Message}");
}
`

const output = `[Required] FirstName: Value is required.
[Email] Email: Value must be a valid email.
[Equal] LastName: Value must equal 'Smithers'.`

function Index(): ReactElement {
  return (
    <Layout>
      <h1>Validatum</h1>
      <p>
        Validatum is an open-source library for building fluent validation
        functions for .NET.
      </p>
      <h2>Platform Support</h2>
      <ul className="list">
        <li>.NET Standard 2.0+</li>
        <li>.NET Core 2.0+</li>
        <li>.NET Framework 4.6.1+</li>
      </ul>
      <h2>Example</h2>
      <div className="">
        <CSharp code={code} />
        <p className="mt-4">The example will produce the output:</p>
        <Shell code={output} />
      </div>
      <h2>Getting Started</h2>
      <ul className="list">
        <li>
          <Link to="/getting-started/installation/">Install via Nuget</Link>
        </li>
        <li>
          <Link to="/getting-started/first-validator/">
            Create your first Validator
          </Link>
        </li>
      </ul>
    </Layout>
  )
}

export default Index
